export function InfoIcon() {
    return (
        <svg
            className="cfg-info-icon"
            viewBox="0 0 16 16"
            aria-hidden="true"
            focusable="false"
            width="1em"
            height="1em"
        >
            <circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" strokeWidth="1.5" />
            <circle cx="8" cy="4.5" r="0.9" fill="currentColor" />
            <path
                d="M8 7.5 L8 11.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                fill="none"
            />
        </svg>
    );
}
